/**
 * PURPOSE: Renderizar un partido compacto en la llave del evento 17.
 * RESPONSIBILITIES: Mostrar enfrentamiento, marcador y código visual de la ronda.
 * COLLABORATORS: Bracket2.jsx y BracketSlot.jsx.
 * ROUTE: frontend/src/components/FullScreenModal/FullScreenEliminatoria/Bracket/BracketMatchCard.jsx
 */
import React from "react";
import BracketSlot from "./BracketSlot";

function visualMatchLabel(match) {
  if (match?.kind === "FINAL") return "Final";
  if (match?.kind === "THIRD") return "3.er puesto";
  return `M${match?.displayOrder || match?.position || ""}`;
}

export default function BracketMatchCard({ match, moodName, emphasized = false }) {
  const official = Number(match?.state) === 4;

  return (
    <article
      data-match-code={match?.code}
      className={`relative z-10 w-[236px] rounded-xl border bg-white p-2.5 transition ${
        emphasized
          ? "border-blue-200 shadow-md"
          : "border-slate-200 shadow-sm"
      }`}
    >
      <header className="mb-2 flex items-center justify-between gap-2 px-0.5">
        <span
          className={`text-xs font-bold ${
            emphasized ? "text-blue-700" : "text-slate-600"
          }`}
        >
          {visualMatchLabel(match)}
        </span>
        {official && (
          <span className="h-2 w-2 rounded-full bg-emerald-500" title="Oficializado" />
        )}
      </header>

      <div className="space-y-1.5">
        <BracketSlot slot={match?.slots?.[0]} moodName={moodName} />
        <BracketSlot slot={match?.slots?.[1]} moodName={moodName} />
      </div>

      {match?.score && official && (
        <div className="mt-2 rounded-lg bg-slate-900 px-2.5 py-1.5 text-center text-xs font-bold text-white">
          {match.score}
        </div>
      )}
    </article>
  );
}
